var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B0082"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2917 28.9583H18.5417V22.9167H17.75C17.2667 22.9167 16.875 22.525 16.875 22.0417V20.4583C16.875 19.975 17.2667 19.5833 17.75 19.5833H18.5417V17.5C18.5417 15.775 19.9417 14.375 21.6667 14.375H23.9167C24.4 14.375 24.7917 14.7667 24.7917 15.25V17.25C24.7917 17.7333 24.4 18.125 23.9167 18.125H22.2917V19.5833H23.8583C24.125 19.5833 24.3667 19.7 24.5333 19.9C24.7 20.1 24.7667 20.3667 24.7167 20.625L24.4 22.2083C24.3167 22.6167 23.9583 22.9083 23.5417 22.9083H22.2917V28.9583ZM19.7917 27.7083H21.0417V21.6667H23.2417L23.4083 20.8333H21.05V17.75C21.05 17.2667 21.4417 16.875 21.925 16.875H23.55V15.625H21.6667C20.6333 15.625 19.7917 16.4667 19.7917 17.5V20.8333H18.125V21.6667H19.7917V27.7083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 28.9582H17.4998C12.9748 28.9582 11.0415 27.0248 11.0415 22.4998V17.4998C11.0415 12.9748 12.9748 11.0415 17.4998 11.0415H22.4998C27.0248 11.0415 28.9582 12.9748 28.9582 17.4998V22.4998C28.9582 27.0248 27.0248 28.9582 22.4998 28.9582ZM17.4998 12.2915C13.6582 12.2915 12.2915 13.6582 12.2915 17.4998V22.4998C12.2915 26.3415 13.6582 27.7082 17.4998 27.7082H22.4998C26.3415 27.7082 27.7082 26.3415 27.7082 22.4998V17.4998C27.7082 13.6582 26.3415 12.2915 22.4998 12.2915H17.4998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame49);
export default __webpack_public_path__ + "static/media/Frame 49.767bd94843464373fe55d113d6b21294.svg";
export { ForwardRef as ReactComponent };